/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React from 'react'
import autoBind from 'react-autobind'
import { injectIntl } from 'react-intl'
import { AutoComplete as MaterialAutoComplete, CircularProgress } from 'material-ui'
import { isDisabled } from './fields'
import * as constants from './constants'
import { red500 } from 'material-ui/styles/colors'

class AutoCompleteField extends React.Component {
  constructor (props) {
    super(props)
    autoBind(this)
  }

  setFloatingLabelText (floatingLabelText, meta) {
    if (floatingLabelText && meta && meta.mandatory) {
      return [floatingLabelText, <span key={0} style={{color: red500, fontSize:20, verticalAlign:'sub'}}> *</span>]
    }

    return floatingLabelText
  }

  handleUpdateInput (searchText, dataSource) {
    if (this.props.onUpdateInput) {
      this.props.onUpdateInput(searchText, dataSource)
    }
  }

  render () {
    const { meta, placeholderMandatory, floatingLabelText, onUpdateInput, ...rest } = this.props

    const componentProps = {
      disabled: isDisabled(meta),
      floatingLabelText: this.setFloatingLabelText(floatingLabelText, meta),
      ...rest
    }

    return (
      <div style={{position: 'relative'}}>
        <MaterialAutoComplete
          floatingLabelFixed
          onUpdateInput={this.handleUpdateInput}
          filter={MaterialAutoComplete.noFilter}
          placeholder={
            placeholderMandatory
              ? this.props.intl.formatMessage(constants.messages.MESSAGE_MANDATORY)
              : this.props.placeholder
          }
          {...componentProps}
        />

        {
          this.props.loading
            ? <CircularProgress
              size={20}
              thickness={2}
              style={{
                position: 'absolute',
                bottom: this.props.loadingBottom != null
                      ? this.props.loadingBottom : (this.props.searchText ? 40 : 15),
                right: 25
              }}
            />
            : undefined
        }

        {
          meta &&
          meta.mandatory &&
          !this.props.searchText &&
          !placeholderMandatory &&
          !this.props.errorText
            ? <p className={'error-message'} style={{margin: 0}}>
              {this.props.intl.formatMessage(constants.messages.MESSAGE_MANDATORY)}
            </p>
            : null
        }
      </div>
    )
  }
}

export default injectIntl(AutoCompleteField)



// WEBPACK FOOTER //
// ./src/generic/form/AutoCompleteField.js